/* eslint-disable react/no-this-in-sfc */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable max-classes-per-file */
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './reactQuill.css';
import uniqueId from 'react-html-id';
import { Component } from 'react';
import { debounce } from '@material-ui/core';
import { uploadBannerImage } from 'src/services/napi';

const BlockEmbed = Quill.import('blots/block/embed');

class DividerBlot extends BlockEmbed {}
DividerBlot.blotName = 'divider';
DividerBlot.tagName = 'hr';
DividerBlot.className = 'divider-blot';

class CustomWhiteSpace extends BlockEmbed {
  static create(text) {
    const node = super.create();
    node.setAttribute(
      'style',
      'background-color: white; padding: 24px 20px; color: black; width: 100%; border-radius: 32px'
    );
    node.innerText = text;
    return node;
  }

  static value(node) {
    return node.childNodes[0].textContent;
  }
}
CustomWhiteSpace.blotName = 'customWhiteSpace';
CustomWhiteSpace.tagName = 'div';
CustomWhiteSpace.className = 'whiteSpace';
Quill.register(CustomWhiteSpace);

class ImageBlot extends BlockEmbed {
  static create(value) {
    const node = super.create();
    node.setAttribute('alt', value.alt);
    node.setAttribute('src', value.url);
    return node;
  }

  static value(node) {
    return {
      alt: node.getAttribute('alt'),
      url: node.getAttribute('src')
    };
  }
}
ImageBlot.blotName = 'image';
ImageBlot.tagName = 'img';
ImageBlot.className = 'customImage';

const WhiteSpaceTag = () => <span>⚪</span>;

function test() {
  const range = this.quill.getSelection(true);
  this.quill.insertText(range.index, '\n');
  this.quill.insertEmbed(range.index + 1, 'divider', true);
  this.quill.setSelection(range.index + 2);
}

function insertWhiteSpace() {
  const range = this.quill.getSelection();

  if (range && range.length > 0) {
    const text = this.quill.getText(range.index, range.length);
    this.quill.deleteText(range.index, range.length);
    this.quill.insertEmbed(range.index, 'customWhiteSpace', text);
  }
}

// function uploadImage() {
//   const range = this.quill.getSelection(true);
//   this.quill.insertText(range.index, '\n');
//   this.quill.insertEmbed(range.index + 1, 'image', {
//     alt: 'testing',
//     url: `${API_URL}/v1/project/${projectId}/file/upload`
//   });
//   this.quill.setSelection(range.index + 2);
// }

function imageHandler() {
  const project = JSON.parse(localStorage.getItem('currentProject'));
  const range = this.quill.getSelection();

  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');
  input.click();
  input.onchange = async () => {
    const file = input.files[0];

    // file type is only image.
    if (/^image\//.test(file.type)) {
      const formData = new FormData();
      formData.append('file', file);
      const response = await uploadBannerImage(formData, project._id);

      this.quill.insertEmbed(range.index, 'image', response.data.file.url);
    } else {
      console.warn('You could only upload images.');
    }
  };
}

class CReactQuill extends Component {
  constructor(props) {
    super();

    uniqueId.enableUniqueIds(CReactQuill);

    this.modules = {
      toolbar: {
        container: `#${CReactQuill.nextUniqueId()}`,
        handlers: {
          customWhiteSpace: insertWhiteSpace,
          image: imageHandler,
          test
        }
      }
    };
    this.props = props;

    this.handleChange = debounce(this.handleChange.bind(this), 150);
  }

  handleChange = (value, delta, source, editor) => {
    const { onChange } = this.props;

    onChange(value, delta, source, editor);
  };

  render() {
    return (
      <div className="text-editor">
        <div id={`${CReactQuill.lastUniqueId()}`}>
          <span className="ql-formats">
            <select className="ql-header" defaultValue="3">
              <option value="1">Heading</option>
              <option value="2">Subheading</option>
              <option value="3">Normal</option>
            </select>
          </span>
          <span className="ql-formats">
            <button className="ql-bold" />
            <button className="ql-italic" />
            <button className="ql-underline" />
            <button className="ql-strike" />
          </span>
          <span className="ql-formats">
            <button className="ql-list" value="ordered" />
            <button className="ql-list" value="bullet" />
            <button className="ql-indent" value="-1" />
            <button className="ql-indent" value="+1" />
          </span>
          <span className="ql-formats">
            <button className="ql-script" value="super" />
            <button className="ql-script" value="sub" />
            <button className="ql-blockquote" />
            <button className="ql-direction" />
          </span>
          <span className="ql-formats">
            <select className="ql-color">
              <option value="red" />
              <option value="green" />
              <option value="blue" />
              <option value="orange" />
              <option value="violet" />
              <option value="#d0d1d2" />
              <option value="#F37021" />
              <option value="#808285" />
              <option value="#27AAE1" />
              <option value="#160F3E" />
              <option value="#FFFFFF" />
              <option value="#CBCCCC" />
              <option value="#6DCFF6" />
              <option value="#363373" />
              <option value="#F04E23" />
              <option value="#000000" />
              <option selected />
            </select>
            <select className="ql-background">
              <option value="red" />
              <option value="green" />
              <option value="blue" />
              <option value="orange" />
              <option value="violet" />
              <option value="#d0d1d2" />
              <option value="#F37021" />
              <option value="#808285" />
              <option value="#27AAE1" />
              <option value="#160F3E" />
              <option value="#FFFFFF" />
              <option value="#CBCCCC" />
              <option value="#6DCFF6" />
              <option value="#363373" />
              <option value="#F04E23" />
              <option value="#000000" />
              <option selected />
            </select>
          </span>
          <span className="ql-formats">
            <button className="ql-link" />
            <button className="ql-image" />
            <button className="ql-video" />
          </span>
          <span className="ql-formats">
            <button className="ql-formula" />
            <button className="ql-code-block" />
            <button className="ql-clean" />
          </span>
          <button className="ql-customWhiteSpace">
            <WhiteSpaceTag />
          </button>
        </div>
        <ReactQuill
          modules={this.modules}
          {...this.props}
          onChange={this.handleChange}
          theme="snow"
        />
      </div>
    );
  }
}

export default CReactQuill;
